import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { KapitelProvider } from '../../providers/kapitel/kapitel'

//import { ZiffernUndZahlenPage } from '../../pages/MathematikGrundschule/Lektionen/Zahlen/ZiffernUndZahlen'



const kapitel = [
  { Header: 'Testkapitel', Subheader: 'test', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'testkapitel' },

  { Header: 'Die Zahlen von 0 bis 9', Subheader: '0 1 2 3 4 5 6 7 8 9', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'zahlen0Bis9' },

  { Header: 'Zahlen zusammenzählen', Subheader: '3 + 4 = 7', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'addition0Bis9' },

  { Header: 'alleZahlen', Subheader: '0 1 2 3', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleZahlen' },

  { Header: 'alleMultiplikationen', Subheader: '3 x 4= 12', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleMultiplikationen' },

  { Header: 'alleSubtraktionen', Subheader: '7 - 4 = 3', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleSubtraktionen' },

  { Header: 'alleDivisionen', Subheader: '12 : 3 = 4', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleDivisionen' },

  { Header: 'alleAdditionen', Subheader: '5 + 2 = 7', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleAdditionen' },

  { Header: 'alleVergleichszeichen', Subheader: '3 + 7 > 7', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleVergleichszeichen' },

  { Header: 'allePunktVorStrich', Subheader: '15 : 3 - 4 = 1', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'allePunktVorStrich' },

  { Header: 'alleUmstellungen', Subheader: 'x - 2 = 6', ImagePath: '../../assets/kapitel/zahlen0bis9.png', Kapitel: 'alleUmstellungen' }
];


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  items = kapitel;

  constructor(public navCtrl: NavController, public mykapitel: KapitelProvider) {

  }


  loadKapitel(item: any) {


    console.log('loadkapitel item.Kapitel: ' + item.Kapitel)
    // loadKapitel(kapitel: string) {
    console.log('kapitel: ' + kapitel);

    switch (item.Kapitel) {
      case 'testkapitel':
        this.mykapitel.setactiveKapitel = this.mykapitel.testkapitel();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'zahlen0Bis9':
        this.mykapitel.setactiveKapitel = this.mykapitel.zahlen0Bis9();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'addition0Bis9':
        this.mykapitel.setactiveKapitel = this.mykapitel.addition0Bis9();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleZahlen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleZahlen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleMultiplikationen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleMultiplikationen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleSubtraktionen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleSubtraktionen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleDivisionen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleDivisionen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleAdditionen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleAdditionen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleVergleichszeichen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleVergleichszeichen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'allePunktVorStrich':
        this.mykapitel.setactiveKapitel = this.mykapitel.allePunktVorStrich();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      case 'alleUmstellungen':
        this.mykapitel.setactiveKapitel = this.mykapitel.alleUmstellungen();
        this.navCtrl.push(this.mykapitel.FirstPage);
        break;
      default:
        alert(item.Kapitel + ' ist nicht vorhanden!');
        break;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts